/**
 * ctaBackgroundStyle — shared helper that turns the CTA background config
 * ({bgImageUrl, bgImageOpacity, bgImagePosX, bgImagePosY, bgImageResponsive,
 * bgImageAlign}) into the inline style object used by the CTA renderers.
 *
 * Responsive (default): `background-size: cover` — image scales to fill.
 * Non-responsive: `background-size: auto` — image stays at natural size;
 *                 admin picks left/center/right alignment.
 */
export function ctaBackgroundStyle(cta = {}) {
  const bgUrl = cta.bgImageUrl;
  if (!bgUrl) return null;

  const bgOpacity = Math.max(0, Math.min(100, Number(cta.bgImageOpacity ?? 35))) / 100;
  const bgPosY = Math.max(0, Math.min(100, Number(cta.bgImagePosY ?? 50)));
  const responsive = cta.bgImageResponsive !== false; // default true

  let backgroundSize;
  let backgroundPosition;
  if (responsive) {
    backgroundSize = 'cover';
    const bgPosX = Math.max(0, Math.min(100, Number(cta.bgImagePosX ?? 50)));
    backgroundPosition = `${bgPosX}% ${bgPosY}%`;
  } else {
    backgroundSize = 'auto';
    const alignRaw = (cta.bgImageAlign || 'center').toLowerCase();
    const align = ['left', 'center', 'right'].includes(alignRaw) ? alignRaw : 'center';
    backgroundPosition = `${align} ${bgPosY}%`;
  }

  return {
    backgroundImage: `url(${bgUrl})`,
    backgroundSize,
    backgroundRepeat: 'no-repeat',
    backgroundPosition,
    opacity: bgOpacity,
    mixBlendMode: 'screen',
  };
}
